export default [
    {
        path: '/detail/:id',
        name: 'MobileNewsDetail',
        props: true,
        component: () => import('../../views/detail/MobileNewsDetail.vue')
    }
]
